import { NavLink } from "react-router-dom";
import { useState } from "react";
import companyLogo from "../../assets/logo/Logo_Limitless-healthcare.png";
import "./Header.css";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((o) => !o);
  const closeMenu = () => setIsOpen(false);
  return (
    <header className="app-header" role="banner">
      <div className="container hdr-row">
        <a className="logo" href="/" aria-label="Company home">
          <img src={companyLogo} alt="Company Logo" height={140} width={140} />
        </a>
        <nav className="primary-nav" aria-label="alert">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/safety">Safety Products</NavLink>
          <NavLink to="/disposable">Disposable Products</NavLink>
          <NavLink to="/surgical">Surgical Products</NavLink>
          <NavLink to="/furniture">Furniture</NavLink>
        </nav>
        <button
          className="menu-toggle"
          aria-controls="mobile-nav"
          aria-expanded={isOpen}
          onClick={toggleMenu}
        >
          ☰
        </button>
      </div>
      <nav
        id="mobile-nav"
        //  className="mobile-nav"
        className={`mobile-nav ${isOpen ? "open" : ""}`}
        aria-label="Mobile"
      >
        <NavLink to="/" end onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to="/safety" onClick={closeMenu}>
          Safety Products
        </NavLink>
        <NavLink to="/disposable" onClick={closeMenu}>
          Disposable Products
        </NavLink>
        <NavLink to="/surgical" onClick={closeMenu}>
          Surgical Products
        </NavLink>
        <NavLink to="/furniture" onClick={closeMenu}>
          Furniture
        </NavLink>
      </nav>
      <style>{`
        .app-header{position:sticky;top:0;z-index:50;background:#ffffffcc;backdrop-filter:saturate(180%) blur(8px);border-bottom:1px solid var(--border)}
        .hdr-row{display:flex;align-items:center;gap:16px;height:72px}
        .logo img{display:block}
        .primary-nav{display:flex;gap:10px}
        .primary-nav a{padding:10px 12px;border-radius:8px}
        .primary-nav a.active{background:#e6f6fd;color:#035b7c}
        .hdr-search{display:flex;gap:8px;margin-left:auto}
        .hdr-search input{height:40px;border:1px solid var(--border);border-radius:8px;padding:0 12px;background:#fff;min-width:260px}
        .hdr-search button{height:40px;padding:0 14px;border-radius:8px;border:0;background:var(--brand);color:#fff}
        .menu-toggle{display:none;background:none;border:0;font-size:22px}
        .mobile-nav{display:none;flex-direction:column;padding:12px;border-top:1px solid var(--border);background:#fff}
        .mobile-nav.open{display:flex}
        .mobile-nav a{padding:12px 8px;border-radius:8px}
        .mobile-nav a.active{background:#e6f6fd;color:#035b7c}
        @media(max-width:960px){
          .hdr-search{display:none}
          .menu-toggle{display:inline-block}
          .primary-nav{display:none}
        }
      `}</style>
    </header>
  );
}
